// extracted by mini-css-extract-plugin
export default {"requirement":"Requirement_requirement__zHNFr","text":"Requirement_text__sgHYw"};